import { render, staticRenderFns } from "./PaginaAdminBoletas.vue?vue&type=template&id=388dfcd8"
import script from "./PaginaAdminBoletas.vue?vue&type=script&lang=js"
export * from "./PaginaAdminBoletas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports